<template>
  <h1 class="report__default-card-title" :style="styles">{{ text }}</h1>
</template>
<script>
export default {
  props: {
    text: [String, Number],
    sizeVariation: [String, Number],
  },
  computed: {
    styles() {
      let fontSize = 20;
      if (this.sizeVariation === 'medium') fontSize = 16;
      if (this.sizeVariation === 'small') fontSize = 12;

      return {
        fontSize: `${fontSize}px`,
      };
    },
  },
};
</script>

<style>
.report__default-card-title {
  font-family: 'DM Sans';
  color: black;
  margin-bottom: 0;
}
</style>
